import { useCallback } from 'react';

import { notify } from '@/actions/ui';
import { handleFileUploadError } from '@/core/attachment';
import { useAppDispatch } from '@/store';

// Catch handler for the open*Dialog helpers: shows the failure in the app snackbar.
export function useFileUploadErrorHandler() {
  const dispatch = useAppDispatch();
  return useCallback(
    (error: unknown, subject?: string) => {
      dispatch(notify(handleFileUploadError(error, subject), 'error'));
    },
    [dispatch]
  );
}
